<template>
  <div
    class="spnod-admin__form--container container mx-0 w-100"
    :class="isMobile ? 'px-0' : 'px-3'">
    <div class="position__relative">
      <transition name="component-fade" mode="out-in">
        <b-form v-if="!displaySuccess" @submit.stop.prevent="handleSubmit" class="position__absolute--center">
          <p class="position__relative--lower mb-3 spnod-admin__form--small-text">You will be sent a link to the email you enter below</p>
          <b-form-group class="mb-4">
            <b-form-input
              v-model="$v.form.email.$model"
              name="email"
              :state="validateState('email')"
              type="email"
              placeholder="Email"
              size="sm"
              class="mb-2"
            ></b-form-input>
            <ul class="spnod-admin__form--list position__relative--left">
            <li>
              <router-link class="spnod-admin__form--link" to="/login">Login</router-link>
            </li>
          </ul>
          </b-form-group>
          <ul v-if="displayErrors" class="spnod-text--error spnod-text--center">
            <li v-for="error in forgotPasswordErrors" class="spnod-list__item">
              {{error}}
            </li>
          </ul>
          <b-form-group class="d-flex justify-content-end">
            <b-button class="spnod-admin__form--button" type="submit" size="sm" :disabled="isDisabled">
              <p v-if="!isSending">Send</p>
              <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></b-button>
          </b-form-group>
        </b-form>
        <p v-else class="position__absolute--lower">{{ forgotPasswordSuccess }}</p>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
  name: 'ForgotPasswordForm',
  mixin: [validationMixin],
  data() {
    return {
      form: {
        isAdmin: true,
        email: ''
      },
      forgotPasswordErrors: [],
      forgotPasswordSuccess: '',
      isSending: false
    }
  },
  computed: {
    isDisabled() {
      const anyBlanks = Object.entries(this.form).some((k, v) => v === '')
      return anyBlanks || this.$v.form.$anyError
    },
    displayErrors() {
      return this.forgotPasswordErrors.length > 0
    },
    displaySuccess() {
      return this.forgotPasswordSuccess !== ''
    },
    isMobile() { return window.innerWidth <= 768 }
  },
  methods: {
    ...mapActions(['doForgotPassword']),
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    handleSubmit: async function (e) {
      this.$v.form.$touch()

      if (this.$v.form.$anyError) {
        return
      }

      this.isSending = true
      await this.doForgotPassword(this.form)
    }
  },
  beforeCreate () {
    this.$store.commit('FORGOTPASSWORDFIELDSET')
  },
  beforeDestroy () {
    this.subscriptions()
  },
  mounted () {
    this.subscriptions = this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'LOGOUT':
          this.$store.dispatch('checkNested', { obj: mutation, props: ['payload', 'data', 'success'] }).then((res) => {
            if (res === false) { return false }
            if (res === 'Password reset sent' || res === 'Password reset email sent') {
              this.forgotPasswordSuccess = res
              setTimeout(() => { this.$router.push('/login') }, 2000)
            } else {
              this.forgotPasswordErrors = [res]
            }
          })
          break
      }
    })
  },
  validations: {
    form: {
      email: { required, email }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/ForgotPasswordForm.vue?7dccdddc